import Content from "uxp-documentation/src/pages/uxp-api/reference-css/General/calc";
import * as React from 'react';
export default {
  Content,
  React
};